<script setup lang="ts">
import { DefectTypes } from 'Modules/types/pages/imageReview/enums'
import useTailwindColor from 'Common/utils/useTailwindColor'

interface PropTypes {
  measurementsSummaryData
}

const props = defineProps<PropTypes>()
const headerColor = useTailwindColor('slate-300')
const headerTextColor = useTailwindColor('slate-700')
</script>

<template>
  <div id="summary-defect-stats" class="h-full w-full rounded-t-md">
    <div class="h-8 flex items-center text-slate-600 font-semibold mt-2 mb-4">Defects Found Summary</div>
    <div class="table-container rounded-md overflow-clip">
      <el-table
        :data="props.measurementsSummaryData"
        :default-sort="{ prop: 'count', order: 'descending' }"
        stripe
        :border="false"
        style="width: 100%; height: 100%"
      >
        <el-table-column prop="DefectTypes[type]" label="Type" width="120">
          <template #default="scope">
            <div class="border-r-2 flex items-center justify-start">
              <span class="font-semibold">
                {{ DefectTypes[scope.row.type] }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="Count" />
        <el-table-column prop="max" label="Max (cm²)" />
        <el-table-column prop="min" label="Min (cm²)" />
        <el-table-column prop="sum" label="Sum (cm²)" />
      </el-table>
    </div>
  </div>
</template>

<style scoped>
/* Override Element Plus table header styles */
:deep(.el-table th) {
  background-color: v-bind(headerColor);
  color: v-bind(headerTextColor);
}
</style>
